export type ChannelType = 'public' | 'local' | 'group'

export interface RadioChannel {
  id: string
  name: string
  type: ChannelType
  memberCount: number
  createdAt: string
}

export type PTTState = 'idle' | 'transmitting' | 'receiving'

export interface RadioState {
  activeChannelId: string | null
  pttState: PTTState
  isMuted: boolean
  peers: string[]
}

export type SignalType = 'offer' | 'answer' | 'ice-candidate' | 'bye'

export interface SignalMessage {
  type: SignalType
  from: string
  to: string
  channelId: string
  payload: unknown
}

export const LOCAL_CHANNEL_RADIUS_KM = 15
export const LOCAL_CHANNEL_GEOHASH_PRECISION = 5
